import axios from 'axios'
import qs from 'qs'
import type { LeadPostResult, LeadPostPayload } from '@/types'
import { getCampaignConfig } from '@/config/campaign-keys'

const LEADSPEDIA_URL = 'https://bluemodomedia.leadspediatrack.com/post.do'

export async function postLead(
  data: Omit<LeadPostPayload, 'lp_campaign_id' | 'lp_campaign_key' | 'lp_response'>,
  affId: string = '0'
): Promise<LeadPostResult> {
  const config = getCampaignConfig(affId)

  const payload: LeadPostPayload = {
    lp_campaign_id: config.lp_campaign_id,
    lp_campaign_key: config.lp_campaign_key,
    lp_response: 'json',
    ...data,
  }

  try {
    const response = await axios.post(
      LEADSPEDIA_URL,
      qs.stringify(buildFormPayload(payload)),
      {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        timeout: 30000,
      }
    )

    const result = response.data

    // Check for duplicate
    const isDuplicate =
      result.msg === 'Lead Rejected' &&
      result.errors?.some((e: any) => e.error?.toLowerCase().includes('duplicate'))

    // Extract advertiser ID
    let advertiserId: string | undefined
    if (result.result === 'success' && result.clients) {
      const successClient = result.clients.find((c: any) => c.client?.success === 'true')
      advertiserId = successClient?.client?.advertiserID
    }

    return {
      success: result.result === 'success',
      leadId: result.lead_id,
      revenue: Number(result.price || 0),
      redirectUrl: result.redirect_url,
      advertiserId,
      isDuplicate,
      message: result.msg,
    }
  } catch (error: any) {
    console.error('Lead post error:', error)
    return {
      success: false,
      error: error.message,
    }
  }
}

// Convert all values to strings for form post
function buildFormPayload(obj: Record<string, any>): Record<string, string> {
  const out: Record<string, string> = {}

  for (const [key, value] of Object.entries(obj)) {
    if (value === undefined || value === null) {
      out[key] = ''
    } else if (typeof value === 'boolean') {
      out[key] = value ? '1' : '0'
    } else if (typeof value === 'number') {
      out[key] = String(value)
    } else if (typeof value === 'object') {
      // Handle objects - stringify them or skip
      out[key] = JSON.stringify(value)
    } else {
      out[key] = String(value)
    }
  }

  return out
}
